// extracted by mini-css-extract-plugin
export default {"content":"page_content__aqtjH","button-content":"page_button-content__5LGur"};